<div class="dialog">
  @if (surveys && surveys.length) {
    <div class="dialog__nav-right-button">
      <span>
        <app-icon (click)="!isLastRecord && loadNextSurvey()" [color]="isLastRecord ? 'var(--gray-700)' : 'var(--white)'" iconName="chevron-right" size="20px" style="cursor: pointer"></app-icon>
      </span>
    </div>
    <div class="dialog__nav-left-button">
      <span>
        <app-icon (click)="!isFirstRecord && loadPrevSurvey()" [color]="isFirstRecord ? 'var(--gray-700)' : 'var(--white)'" iconName="chevron-left" size="20px" style="cursor: pointer"></app-icon>
      </span>
    </div>
  }
  @if (isMobileView()) {
    <div class="mobile-app-bar right-action-icons-only sticky-header">
      @if (canEditDelete) {
        <div class="mobile-app-bar__action-icon">
          @if (isUserOwner || _permissionService.isAdmin()) {
            <app-icon (click)="editSurveyBottomSheet(currentSurvey)" iconName="pencil" size="16px"></app-icon>
          }
        </div>
        <div class="mobile-app-bar__action-icon">
          @if (isUserOwner || _permissionService.isAdmin()) {
            <app-icon (click)="deleteSurvey(currentSurvey)" iconName="trash" size="16px"></app-icon>
          }
        </div>
      }
      <div class="mobile-app-bar__action-icon">
        <app-icon (click)="close()" iconName="close" size="16px"></app-icon>
      </div>
    </div>
  }
  @if (!isMobileView()) {
    <header class="dialog__header">
      <h3 class="dialog__header__title"></h3>
      <div class="dialog__header__action-buttons">
        @if (canEditDelete) {
          <div class="dialog__header__action-buttons__button">
            @if (isUserOwner || _permissionService.isAdmin()) {
              <app-icon (click)="editSurveyDialog()" [cssStyle]="{ margin: '4px' }" iconName="pencil" size="20px"></app-icon>
            }
          </div>
          <div class="dialog__header__action-buttons__button">
            @if (isUserOwner || _permissionService.isAdmin()) {
              <app-icon (click)="deleteSurvey(currentSurvey)" [cssStyle]="{ margin: '4px' }" iconName="trash-bin" size="20px"></app-icon>
            }
          </div>
        }
        <div class="dialog__header__action-buttons__button">
          <app-icon (click)="closeDialog()" [cssStyle]="{ margin: '4px' }" iconName="close" size="20px"></app-icon>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    @if (!isLoading && currentSurvey.title && alertType) {
      <app-alert-message [alertType]="alertType" [denyReason]="currentSurvey?.denyReason" [showCloseIcon]="false" size="small"></app-alert-message>
    }

    <div class="img-wrapper background-loading">
      <img [src]="currentSurvey?.imageUrl" alt="" appDefaultImage="assets/images/defaults/survey.png" loading="lazy" />
    </div>
    @if (!isLoading) {
      <h5 class="survey-title">{{ currentSurvey?.title }}</h5>
    } @else {
      <ngx-skeleton-loader [count]="1" [theme]="{ marginTop: '16px' }" count="1"></ngx-skeleton-loader>
    }
    @if (!isLoading) {
      <article [innerHTML]="currentSurvey?.description" class="survey-text"></article>
    } @else {
      <ngx-skeleton-loader [count]="1" [theme]="{ marginTop: '16px' }" count="1"></ngx-skeleton-loader>
    }
    <div class="mt-24">
      @if (!surveyLoaders.isFormLoading) {
        @if (pollType !== SurveyPollType.COMPLETED_POLLS && pollType !== SurveyPollType.MY_POLLS && (!currentSurvey.additionalCastVote || (currentSurvey.additionalCastVote && checkMyVote()))) {
          @if (+currentSurvey?.status !== SurveyStatus.Close) {
            <div class="card">
              <!--  ---- SINGLE OPTION VOTING ---- -->
              @if (currentSurvey.option === SurveyOptions.SingleChoice && currentSurvey?.status === SurveyStatus.Active) {
                <ng-container>
                  <h3 translate>My Vote: You can select only one option</h3>
                  <form [formGroup]="form" class="mt-15">
                    @for (fields of currentSurvey?.surveyAnswer; track fields; let i = $index) {
                      <div class="radio-group">
                        <input (change)="onRadioChange($event)" [type]="'radio'" [value]="fields.id" class="radio" id="{{ i }}" name="radio" />
                        <label for="{{ i }}">{{ fields.surveyAnswer }}</label>
                        <!--                  <app-form-error [control]="form.get('surveyAnswerId')" [name]="'Answer' | translate"></app-form-error>-->
                      </div>
                    }
                    <div class="mt-16">
                      <app-button (clickEvent)="saveVote($event)" [disabled]="form.invalid" [idleText]="'To Vote' | translate"></app-button>
                    </div>
                  </form>
                </ng-container>
              }
              <!--  ---- Multiple OPTION VOTING ---- -->
              @if (currentSurvey.option === SurveyOptions.MultipleChoice && currentSurvey?.status === SurveyStatus.Active) {
                <ng-container>
                  <h3 translate>My Vote: You can select Multiple Options</h3>
                  <form [formGroup]="form" class="mt-15">
                    @for (answer of currentSurvey?.surveyAnswer; track answer; let i = $index) {
                      <div class="checkbox-group">
                        <input (change)="onCheckboxChange(answer.id, $event.target.checked)" [id]="'checkbox-' + i" class="checkbox" name="checkbox" type="checkbox" />
                        <label [for]="'checkbox-' + i">{{ answer.surveyAnswer }}</label>
                      </div>
                    }
                    <div class="mt-16">
                      <app-button (clickEvent)="saveVote($event)" [disabled]="form.invalid" [idleText]="'To Vote' | translate"></app-button>
                    </div>
                  </form>
                </ng-container>
              }
            </div>
          }
        }
      } @else {
        <ngx-skeleton-loader
          [count]="2"
          [theme]="{
            height: '160px',
          }"
          count="1"
        ></ngx-skeleton-loader>
      }

      <!-- survey options -->

      @if (!surveyLoaders.isResultLoading) {
        @if (userVotedAnswers && userVotedAnswers.length > 0) {
          <div class="card">
            <h3 translate>My Vote</h3>
            <div class="voting-options mt-10">
              @if (userVotedAnswers) {
                @for (answer of userVotedAnswers; track answer) {
                  <div class="radio-group custom-radio">
                    <input [type]="'radio'" checked class="radio" readonly />
                    <label>{{ answer?.surveyAnswer?.surveyAnswer }}</label>
                  </div>
                }
              }
            </div>
          </div>
        }
        @if ((!userVotedAnswers || !userVotedAnswers.length) && pollType === SurveyPollType.COMPLETED_POLLS && checkMyVote()) {
          <div class="card">
            <h2 class="survey-title" translate>You've not voted</h2>
          </div>
        }
        @if (+currentSurvey?.status === SurveyStatus.Close) {
          <ng-container class="card">
            <div class="voting-options 2">
              <span translate>Survey Has been Closed</span>
            </div>
          </ng-container>
        }
      } @else {
        <ngx-skeleton-loader
          [count]="2"
          [theme]="{
            height: '160px',
          }"
          count="1"
        ></ngx-skeleton-loader>
      }

      @if (!surveyLoaders.isResultLoading) {
        @if (showVote(currentSurvey)) {
          <!-- VOTE RESULT START -->
          <div class="card result-last">
            <h3 translate>
              Survey Results
              @if (surveyLoaders.isVotedByResultsLoading) {
                <app-icon iconName="spinner-orange" marginRight="10px" size="16px"></app-icon>
              }
            </h3>
            <div class="voting-options 4">
              <ul>
                @for (value of currentSurvey?.surveyAnswer; track value; let j = $index) {
                  <li>
                    <h4>{{ value.surveyAnswer | truncateText: 20 }}</h4>
                    @for (survey of surveyResults?.answerCount; track survey) {
                      @if (survey?.answerId === value?.id) {
                        <div class="progress-bar">
                          <div [ngClass]="{ 'bg-success': j === 0, 'bg-warning': j > 0 }" [style.width.%]="survey.percentageValue" class="progress"></div>
                        </div>
                      }
                      @if (survey?.answerId === value?.id) {
                        <span>
                          <a (click)="openVoteResultDialogBox(value?.surveyId, value?.id)" [class.disabled]="surveyLoaders.isVotedByResultsLoading" style="cursor: pointer"
                            >{{ +survey?.count }}
                            {{ 'Votes' | translate }}
                          </a>
                        </span>
                      }
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
          <!-- VOTE RESULT END -->
        }
      } @else {
        <ngx-skeleton-loader
          [count]="2"
          [theme]="{
            height: '160px',
          }"
          count="1"
        ></ngx-skeleton-loader>
      }
    </div>
    <!-- Dialog Footer -->
    <!--    <footer>-->
    <!--      <div class="dialog__footer">-->
    <!--        <div *ngIf="!isMobileView()" class="dialog__footer__buttons">-->
    <!--          <div class="main-image-wrapper background-loading-small">-->
    <!--            <img [appFetchProfileImage]="currentSurvey?.owner?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />-->
    <!--          </div>-->
    <!--          <div>-->
    <!--            <span class="create-text" translate>Survey Created By</span>-->
    <!--            <label>{{ currentSurvey?.owner?.fullName }}</label>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </footer>-->
  </div>
</div>
